import React from "react";

const Icon = ({ color }: { color: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill={color}
      d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    />
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill={color}
      d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    />
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill={color}
      d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    />
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill={color}
      d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    />
  </svg>
);

function convert({ type, props }: JSX.Element): string {
  const { children } = props;
  let str = `<${type} `;

  for (const k in props) {
    if (k === "children") continue;
    if (k === "viewBox") {
      str += k;
    } else {
      const attribute = k.toLowerCase();
      for (let i = 0; i < attribute.length; i++) {
        const letter = attribute[i];
        if (k[i] !== letter) str += "-";
        str += letter;
      }
    }
    str += `="${props[k]}" `;
  }

  str += ">";

  if (children) for (const child of children) str += convert(child);

  return str + `</${type}>`;
}

function toDataUrl<T>(Svg: (props: T) => JSX.Element, props: T) {
  return `data:image/svg+xml,${encodeURIComponent(convert(Svg(props)))}`;
}

const iconDataUrl = toDataUrl(Icon, { color: "blue" });

export default function App() {
  const [renderer, setRenderer] = React.useState("jsx");
  const [visible, setVisible] = React.useState(true);
  const [nextRafTime, setNextRafTime] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRenderer(event.currentTarget.value);
    setVisible(false);
  };

  React.useEffect(() => {
    const id = setTimeout(() => {
      const start = Date.now();
      requestAnimationFrame(() => {
        // this rAF called pefore paint and other operations
        requestAnimationFrame(() => {
          // this rAF called defenetly after all work
          setNextRafTime(Date.now() - start);
        });
      });
      setVisible(true);
    }, 1000);
    return () => clearTimeout(id);
  }, [renderer]);

  return (
    <div className="App">
      <select onChange={handleChange}>
        <option value="jsx">jsx</option>
        <option value="img">img</option>
      </select>
      time to next rAF: {nextRafTime}ms
      <br />
      <section style={{ display: "flex", flexWrap: "wrap" }}>
        {visible &&
          Array.from({ length: 1000 }).map(() => (
            <div style={{ width: "2rem" }}>
              {renderer === "jsx" ? (
                <Icon color="purple" />
              ) : (
                <img src={iconDataUrl} />
              )}
            </div>
          ))}
      </section>
    </div>
  );
}
